import { render, staticRenderFns } from "./ChbEditPageHeader.vue?vue&type=template&id=e42dad8c&scoped=true"
import script from "./ChbEditPageHeader.vue?vue&type=script&lang=js"
export * from "./ChbEditPageHeader.vue?vue&type=script&lang=js"
import style0 from "./ChbEditPageHeader.vue?vue&type=style&index=0&id=e42dad8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42dad8c",
  null
  
)

export default component.exports